import React from 'react';
import { Card } from 'react-bootstrap';
import Flex from 'components/common/Flex';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import PropTypes from 'prop-types';
import IconButton from 'components/common/IconButton';

const LocationTable = ({ data }) => {
  const openMap = from => {
    const url = `https://maps.google.com/?q=${from}`;
    // const url = `https://maps.google.com/?saddr=${from},&daddr=${to}}`;

    // Open the URL in a new tab
    window.open(url, '_blank');
  };

  const columns = [
    {
      accessorKey: 'location_id',
      header: 'Location Id',
      meta: {
        headerProps: { className: 'pe-1 text-900' },
        cellProps: {
          className: 'py-2'
        }
      },
      cell: ({ row: { original } }) => {
        const { location_id } = original;
        return (
          <Flex alignItems="center">
            <div className="flex-1">
              <h5 className="mb-0 fs-10">{location_id}</h5>
            </div>
          </Flex>
        );
      }
    },
    {
      accessorKey: 'location_fullAddress',
      header: 'FullAddress',
      meta: {
        headerProps: { className: 'text-900' }
      },
      cell: ({ row: { original } }) => {
        const { location_fullAddress } = original;
        return <h5 className="mb-0 fs-10">{location_fullAddress}</h5>;
      }
    },
    {
      accessorKey: 'none',
      header: '',
      enableSorting: false,
      meta: {
        cellProps: {
          className: 'text-end'
        }
      },
      cell: ({ row: { original } }) => {
        const { location_fullAddress } = original;
        return (
          <IconButton
            variant="primary"
            iconClassName="me-2"
            size="sm"
            className="mx-3 my-1"
            onClick={() => openMap(location_fullAddress)}
          >
            <span className="text-light ms-1">View Map</span>
          </IconButton>
        );
      }
    }
  ];

  const table = useAdvanceTable({
    data: data,
    columns,
    // selection: true,
    sortable: true,
    pagination: true,
    perPage: 10
  });

  return (
    <>
      <AdvanceTableProvider {...table}>
        <Card className="mb-3">
          <Card.Body className="p-0">
            <AdvanceTable
              headerClassName="bg-200 text-nowrap align-middle"
              rowClassName="align-middle white-space-nowrap"
              tableProps={{
                size: 'sm',
                striped: true,
                className: 'fs-10 mb-0 overflow-hidden'
              }}
            />
          </Card.Body>
          <Card.Footer>
            <div className="mt-3">
              <AdvanceTableFooter rowInfo navButtons rowsPerPageSelection />
            </div>
          </Card.Footer>
        </Card>
      </AdvanceTableProvider>
    </>
  );
};

LocationTable.propTypes = {
  data: PropTypes.any
};

export default LocationTable;
